<script setup lang="ts">
import { Ref, inject, ref } from 'vue';

import {
  TSDialogForm,
  TSIcon,
  TSInputEmail,
  useLoadingStore,
  useToast,
} from 'tsv2-library';

import { FormPayload } from 'tsv2-library/dist/src/components/v2/Form/Form.vue';

import BorrowingServices from '@/services/borrowing.service';

import { PutUpdateEmailorBorrowerDTO } from '@/dto/borrowingTransaction.dto';

defineProps<{
  name: string;
  email: string;
}>();

const transactionId = inject('transactionId') as Ref<string>;
const getTransactionDetail = inject(
  'getTransactionDetail',
) as () => Promise<void>;

const toast = useToast();
const { setLoading } = useLoadingStore();

const showEditUserEmail = ref<boolean>(false);

/**
 * Handle the submission to edit borowing transaction email
 */
const handleSubmit = async (payload: FormPayload): Promise<void> => {
  try {
    setLoading(true);

    const dataDTO: PutUpdateEmailorBorrowerDTO = {
      email: payload.formValues.email as string,
    };

    await BorrowingServices.putUpdateEmailorBorrower(
      transactionId.value,
      dataDTO,
    );

    await getTransactionDetail();
  } catch (error) {
    toast.add({
      error,
      message: 'Error, failed to edit user email.',
      severity: 'error',
    });
  } finally {
    setLoading(false);
  }
};
</script>
<template>
  <div class="flex gap-4" data-ts-name="edit-email">
    <TSDialogForm
      v-model:visible="showEditUserEmail"
      :reset-after-submit="false"
      :show-stay-checkbox="false"
      :use-clear-btn="false"
      @close="showEditUserEmail"
      @submit="handleSubmit"
      action="Save"
      closable
      header="Edit User Email"
      width="small"
    >
      <template #fields>
        <span>{{ name }}</span>
        <TSInputEmail
          :value="email"
          data-ts-section="email-input"
          field-name="email"
          label="Email"
          mandatory
          placeholder="Enter email"
          use-validator
        />
      </template>
    </TSDialogForm>
    <span>{{ email }}</span>
    <TSIcon
      @click="showEditUserEmail = true"
      class="!h-4 !w-4"
      data-ts-section="edit-email-button"
      icon="edit"
      severity="primary"
    />
  </div>
</template>
